// translations.js
export const translations = {
  ru: {
    // Общие переводы
    common: {
      email: "Email",
      password: "Пароль",
      loading: "Загрузка...",
      required: "обязательно",
      cancel: "Отмена",
      continue: "Продолжить"
    },

    // Переводы для страницы регистрации
    register: {
      title: "Регистрация читателя",
      subtitle: "Заполните все поля для создания читательского билета",
      form: {
        lastName: "Фамилия",
        firstName: "Имя",
        middleName: "Отчество",
        gender: "Пол",
        birthYear: "Год рождения",
        nationality: "Национальность",
        address: "Адрес проживания",
        education: "Образование",
        socialStatus: "Социальный статус",
        workplace: "Место работы",
        academicDegree: "Научная степень",
        studyPlace: "Место учебы",
        confirmPassword: "Подтверждение пароля",
        uploadAvatar: "Загрузить аватар",
      },
      placeholders: {
        lastName: "Введите фамилию",
        firstName: "Введите имя",
        middleName: "Введите отчество",
        birthYear: "Введите год рождения",
        address: "Введите адрес проживания",
        workplace: "Введите место работы",
        academicDegree: "Введите научную степень",
        studyPlace: "Введите место учебы",
        email: "Введите email",
        password: "Введите пароль",
        confirmPassword: "Подтвердите пароль"
      },
      options: {
        gender: {
          male: "Мужской",
          female: "Женский",
          other: "Другое",
          not_specified: "Не указывать"
        },
        nationality: {
          select: "Выберите национальность",
          kazakh: "Казах",
          russian: "Русский",
          ukrainian: "Украинец",
          uzbek: "Узбек",
          tatar: "Татар",
          german: "Немец",
          korean: "Кореец",
          turkish: "Турок",
          other: "Другое"
        },
        education: {
          elementary: "Начальное",
          secondary: "Среднее",
          vocational: "Средне-специальное",
          higher: "Высшее",
          academic_degree: "Ученая степень"
        },
        socialStatus: {
          student: "Студент",
          employed: "Работающий",
          unemployed: "Безработный",
          pensioner: "Пенсионер",
          school_student: "Школьник",
          entrepreneur: "ИП",
          civil_servant: "Госслужащий",
          other: "Другое"
        }
      },
      errors: {
        lastName: "Фамилия обязательна",
        firstName: "Имя обязательно",
        birthYear: {
          required: "Год рождения обязателен",
          invalid: "Некорректный год рождения"
        },
        address: "Адрес проживания обязателен",
        email: {
          required: "Email обязателен",
          invalid: "Некорректный email"
        },
        password: {
          required: "Пароль обязателен",
          length: "Пароль должен содержать минимум 6 символов"
        },
        confirmPassword: "Пароли не совпадают",
        general: "Ошибка регистрации. Попробуйте еще раз.",
        image: "Файл слишком большой. Максимум 15MB"
      },
      buttons: {
        register: "Зарегистрироваться",
        registering: "Регистрация..."
      },
      success: {
        title: "Регистрация успешна!",
        libraryCard: "Ваш читательский билет:",
        welcome: "Добро пожаловать,"
      },
      footer: {
        hasAccount: "Уже есть аккаунт?",
        login: "Войти в систему"
      }
    },

    // Переводы для страницы входа
    login: {
      title: "Вход в систему",
      subtitle: "Войдите в свой аккаунт",
      methods: {
        email: "Через Email",
        libraryCard: "Через читательский билет"
      },
      form: {
        email: "Email адрес",
        libraryCard: "Номер читательского билета",
        password: "Пароль"
      },
      placeholders: {
        email: "Введите email",
        libraryCard: "Введите 6-значный номер",
        password: "Введите пароль"
      },
      hints: {
        libraryCard: "Введите 6-значный номер читательского билета"
      },
      buttons: {
        signIn: "Войти",
        signingIn: "Вход..."
      },
      errors: {
        invalid: "Неверный email/читательский билет или пароль"
      },
      success: {
        title: "Вход успешно осуществлен!",
        libraryCard: "Читательский билет:"
      },
      footer: {
        noAccount: "Нет аккаунта?",
        register: "Зарегистрироваться"
      }
    }
  },

  kz: {
    // Общие переводы
    common: {
      email: "Электрондық пошта",
      password: "Құпия сөз",
      loading: "Жүктелуде...",
      required: "міндетті",
      cancel: "Бас тарту",
      continue: "Жалғастыру"
    },

    // Переводы для страницы регистрации
    register: {
      title: "Оқырман тіркеуі",
      subtitle: "Оқырман билетін жасау үшін барлық өрістерді толтырыңыз",
      form: {
        lastName: "Тегі",
        firstName: "Аты",
        middleName: "Әкесінің аты",
        gender: "Жынысы",
        birthYear: "Туған жылы",
        nationality: "Ұлты",
        address: "Тұрғылықты мекенжайы",
        education: "Білімі",
        socialStatus: "Әлеуметтік мәртебесі",
        workplace: "Жұмыс орны",
        academicDegree: "Ғылыми дәрежесі",
        studyPlace: "Оқу орны",
        confirmPassword: "Құпия сөзді растау",
        uploadAvatar: "Аватарды жүктеу"
      },
      placeholders: {
        lastName: "Тегіңізді енгізіңіз",
        firstName: "Атыңызды енгізіңіз",
        middleName: "Әкесінің атын енгізіңіз",
        birthYear: "Туған жылыңызды енгізіңіз",
        address: "Тұрғылықты мекенжайыңызды енгізіңіз",
        workplace: "Жұмыс орныңызды енгізіңіз",
        academicDegree: "Ғылыми дәрежеңізді енгізіңіз",
        studyPlace: "Оқу орныңызды енгізіңіз",
        email: "Электрондық поштаңызды енгізіңіз",
        password: "Құпия сөзіңізді енгізіңіз",
        confirmPassword: "Құпия сөзді растаңыз"
      },
      options: {
        gender: {
          male: "Ер",
          female: "Әйел",
          other: "Басқа",
          not_specified: "Көрсетпеу"
        },
        nationality: {
          select: "Ұлтыңызды таңдаңыз",
          kazakh: "Қазақ",
          russian: "Орыс",
          ukrainian: "Украин",
          uzbek: "Өзбек",
          tatar: "Татар",
          german: "Неміс",
          korean: "Корей",
          turkish: "Түрік",
          other: "Басқа"
        },
        education: {
          elementary: "Бастауыш",
          secondary: "Орта",
          vocational: "Арнайы орта",
          higher: "Жоғары",
          academic_degree: "Ғылыми дәреже"
        },
        socialStatus: {
          student: "Студент",
          employed: "Жұмыс істейтін",
          unemployed: "Жұмыссыз",
          pensioner: "Зейнеткер",
          school_student: "Мектеп оқушысы",
          entrepreneur: "ЖК",
          civil_servant: "Мемлекеттік қызметкер",
          other: "Басқа"
        }
      },
      errors: {
        lastName: "Тегі міндетті",
        firstName: "Аты міндетті",
        birthYear: {
          required: "Туған жылы міндетті",
          invalid: "Туған жылы дұрыс емес"
        },
        address: "Тұрғылықты мекенжайы міндетті",
        email: {
          required: "Электрондық пошта міндетті",
          invalid: "Электрондық пошта дұрыс емес"
        },
        password: {
          required: "Құпия сөз міндетті",
          length: "Құпия сөз кемінде 6 таңбадан тұруы керек"
        },
        confirmPassword: "Құпия сөздер сәйкес келмейді",
        general: "Тіркеу қатесі. Қайта көріңіз.",
        image: "Файл тым үлкен. Максималды 15MB"
      },
      buttons: {
        register: "Тіркелу",
        registering: "Тіркелуде..."
      },
      success: {
        title: "Тіркеу сәтті өтті!",
        libraryCard: "Сіздің оқырман билетіңіз:",
        welcome: "Қош келдіңіз,"
      },
      footer: {
        hasAccount: "Аккаунтыңыз бар ма?",
        login: "Жүйеге кіру"
      }
    },

    // Переводы для страницы входа
    login: {
      title: "Жүйеге кіру",
      subtitle: "Өз аккаунтыңызға кіріңіз",
      methods: {
        email: "Email арқылы",
        libraryCard: "Оқырман билеті арқылы"
      },
      form: {
        email: "Электрондық пошта мекенжайы",
        libraryCard: "Оқырман билетінің нөмірі",
        password: "Құпия сөз"
      },
      placeholders: {
        email: "Электрондық поштаңызды енгізіңіз",
        libraryCard: "6 таңбалы нөмірді енгізіңіз",
        password: "Құпия сөзіңізді енгізіңіз"
      },
      hints: {
        libraryCard: "Оқырман билетінің 6 таңбалы нөмірін енгізіңіз"
      },
      buttons: {
        signIn: "Кіру",
        signingIn: "Кіруде..."
      },
      errors: {
        invalid: "Email/оқырман билеті немесе құпия сөз қате"
      },
      success: {
        title: "Жүйеге сәтті кірдіңіз!",
        libraryCard: "Оқырман билеті:"
      },
      footer: {
        noAccount: "Аккаунтыңыз жоқ па?",
        register: "Тіркелу"
      }
    }
  },

  en: {
    // Общие переводы
    common: {
      email: "Email",
      password: "Password",
      loading: "Loading...",
      required: "required",
      cancel: "Cancel",
      continue: "Continue"
    },

    // Переводы для страницы регистрации
    register: {
      title: "Reader Registration",
      subtitle: "Fill in all fields to create a library card",
      form: {
        lastName: "Last Name",
        firstName: "First Name",
        middleName: "Middle Name",
        gender: "Gender",
        birthYear: "Birth Year",
        nationality: "Nationality",
        address: "Address",
        education: "Education",
        socialStatus: "Social Status",
        workplace: "Workplace",
        academicDegree: "Academic Degree",
        studyPlace: "Study Place",
        confirmPassword: "Confirm Password"
      },
      placeholders: {
        lastName: "Enter last name",
        firstName: "Enter first name",
        middleName: "Enter middle name",
        birthYear: "Enter birth year",
        address: "Enter your address",
        workplace: "Enter workplace",
        academicDegree: "Enter academic degree",
        studyPlace: "Enter study place",
        email: "Enter email",
        password: "Enter password",
        confirmPassword: "Confirm password",
        uploadAvatar: "Upload avatar",
      },
      options: {
        gender: {
          male: "Male",
          female: "Female",
          other: "Other",
          not_specified: "Not specified"
        },
        nationality: {
          select: "Select nationality",
          kazakh: "Kazakh",
          russian: "Russian",
          ukrainian: "Ukrainian",
          uzbek: "Uzbek",
          tatar: "Tatar",
          german: "German",
          korean: "Korean",
          turkish: "Turkish",
          other: "Other"
        },
        education: {
          elementary: "Elementary",
          secondary: "Secondary",
          vocational: "Vocational",
          higher: "Higher",
          academic_degree: "Academic Degree"
        },
        socialStatus: {
          student: "Student",
          employed: "Employed",
          unemployed: "Unemployed",
          pensioner: "Pensioner",
          school_student: "School Student",
          entrepreneur: "Entrepreneur",
          civil_servant: "Civil Servant",
          other: "Other"
        }
      },
      errors: {
        lastName: "Last name is required",
        firstName: "First name is required",
        birthYear: {
          required: "Birth year is required",
          invalid: "Invalid birth year"
        },
        address: "Address is required",
        email: {
          required: "Email is required",
          invalid: "Invalid email"
        },
        password: {
          required: "Password is required",
          length: "Password must contain at least 6 characters"
        },
        confirmPassword: "Passwords do not match",
        general: "Registration error. Please try again.",
        image: "The file is too large. Maximum 15MB."
      },
      buttons: {
        register: "Register",
        registering: "Registering..."
      },
      success: {
        title: "Registration successful!",
        libraryCard: "Your library card:",
        welcome: "Welcome,"
      },
      footer: {
        hasAccount: "Already have an account?",
        login: "Sign in"
      }
    },

    // Переводы для страницы входа
    login: {
      title: "Sign In",
      subtitle: "Sign in to your account",
      methods: {
        email: "Via Email",
        libraryCard: "Via Library Card"
      },
      form: {
        email: "Email address",
        libraryCard: "Library card number",
        password: "Password"
      },
      placeholders: {
        email: "Enter email",
        libraryCard: "Enter 6-digit number",
        password: "Enter password"
      },
      hints: {
        libraryCard: "Enter 6-digit library card number"
      },
      buttons: {
        signIn: "Sign In",
        signingIn: "Signing in..."
      },
      errors: {
        invalid: "Invalid email/library card or password"
      },
      success: {
        title: "Successfully signed in!",
        libraryCard: "Library card:"
      },
      footer: {
        noAccount: "Don't have an account?",
        register: "Sign up"
      }
    }
  }
};